import { render, staticRenderFns } from "./relevanceCallOutModal.vue?vue&type=template&id=cfc41fea&scoped=true"
import script from "./relevanceCallOutModal.vue?vue&type=script&lang=js"
export * from "./relevanceCallOutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc41fea",
  null
  
)

export default component.exports